import { useQueryClient } from "@tanstack/react-query";

import { CompanySummary } from "@/types";

/**
 * This hook is used to add a new company to the companies summary query
 * without refetching the entire query.
 */
export const useAddCompany = () => {
  const queryClient = useQueryClient();

  return ({ companyToAdd }: { companyToAdd: CompanySummary }) => {
    queryClient.setQueryData(
      ["companies-summary"],
      (cachedData: CompanySummary[]) => {
        // Important to add the new company to the top of the list.
        return [companyToAdd, ...cachedData];
      },
    );
  };
};
